import React from "react"
import { Box, Typography, Button, Stack, Container, Paper, CircularProgress } from "@mui/material"
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline"
import RefreshIcon from "@mui/icons-material/Refresh"

const ErrorPage = ({ missingData }) => {
  const [isLoading, setIsLoading] = React.useState(false)

  const handleReload = () => {
    setIsLoading(true)
    window.location.reload()
  }

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <ErrorOutlineIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant="h4" component="h1" gutterBottom>
          Error en los datos
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 4 }}>
          No se puede mostrar el formulario porque faltan datos requeridos:
        </Typography>

        <Box
          sx={{
            color: "error.main",
            borderRadius: 1,
            width: "80%",
            mb: 4,
          }}
        >
          <Typography variant="body1" component="div">
            {Array.isArray(missingData) ? (
              <ul>
                {missingData.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            ) : (
              missingData
            )}
          </Typography>
        </Box>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
            onClick={handleReload}
            size="large"
            disabled={isLoading}
          >
            Recargar página
          </Button>
        </Stack>
      </Paper>
    </Container>
  )
}

export default ErrorPage
